import { render } from "./FeedbackFilters.vue?vue&type=template&id=4f7bf458"
import script from "./FeedbackFilters.vue?vue&type=script&lang=js"
export * from "./FeedbackFilters.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__